import React, { useState } from "react";
import Closebutton from "assets/closeicon.svg";
import SendMail from "./popup/quotePopUp/sendMail";
import Loader from "./loader";
import Fileicon from "assets/fileicon.svg";

const AttachFile = ({ files, setFiles }) => {
  const [popup, setPopup] = useState(false);
  const [loader, setLoader] = useState(false);
  const [unSupportedFile, setUnSupportedFile] = useState(false);

  const onFileUpload = (e) => {
    const uploadFiles = Array.from(e.target.files);
    uploadFiles?.forEach((file) => {
      setFiles((prevFiles) => [...prevFiles, file]);
    });
  };

  const fileSize = (fileSizeInBytes) => {
    const fileSizeInMB = fileSizeInBytes / (1024 * 1024);
    return `${fileSizeInMB.toFixed(2)} MB`;
  };

  const ValidFileType = (file) => {
    if (typeof file !== "string") return false;
    const type = file.split(".").pop();
    if (type === "pdf" || type === "txt" || type === "docs") return true;
    return false;
  };

  const handleDeleteFile = (id) => {
    const filteredFiles = files.filter((file, i) => i !== id);
    setFiles(filteredFiles);
  };

  return (
    <>
      {files?.length === 0 ? (
        <button
          type="button"
          onClick={() => setPopup(true)}
          className="border max-w-max border-[#A1A1AA] text-[#A1A1AA] flex gap-1 px-3 py-1 rounded-full items-center"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <path
              d="M7.45788 1.9891C7.7971 1.65437 8.20201 1.38779 8.64913 1.20481C9.09625 1.02183 9.57668 0.926094 10.0625 0.923165C10.5484 0.920236 11.0301 1.01017 11.4795 1.18774C11.929 1.36532 12.3373 1.627 12.6809 1.95761C13.0244 2.28823 13.2963 2.68119 13.4808 3.1137C13.6653 3.54621 13.7587 4.00967 13.7556 4.47718C13.7525 4.9447 13.6529 5.40697 13.4627 5.83717C13.2724 6.26737 12.9953 6.65695 12.6474 6.9833L6.93893 12.4768C6.73509 12.6763 6.49223 12.8349 6.22437 12.9435C5.9565 13.0521 5.66894 13.1087 5.37825 13.1099C5.08756 13.111 4.79951 13.0568 4.53071 12.9503C4.26191 12.8438 4.01768 12.6872 3.81211 12.4894C3.60654 12.2917 3.4437 12.0567 3.33297 11.7981C3.22224 11.5395 3.16583 11.2623 3.16698 10.9826C3.16813 10.7029 3.22682 10.4262 3.33966 10.1684C3.45251 9.91066 3.61728 9.67694 3.82448 9.48075L9.5337 3.98721L10.5716 4.9859L4.86238 10.4794C4.79228 10.5446 4.73636 10.6225 4.69789 10.7087C4.65942 10.7949 4.63917 10.8876 4.63832 10.9813C4.63748 11.0751 4.65605 11.1681 4.69295 11.2549C4.72986 11.3417 4.78436 11.4206 4.85328 11.4869C4.9222 11.5532 5.00416 11.6057 5.09437 11.6412C5.18458 11.6767 5.28123 11.6946 5.37869 11.6937C5.47616 11.6929 5.57248 11.6734 5.66203 11.6364C5.75158 11.5994 5.83258 11.5456 5.90029 11.4781L11.6102 5.9846C11.8147 5.78783 11.977 5.55422 12.0876 5.29713C12.1983 5.04003 12.2553 4.76448 12.2553 4.4862C12.2553 4.20792 12.1983 3.93237 12.0876 3.67527C11.977 3.41818 11.8147 3.18457 11.6102 2.9878C11.4057 2.79103 11.163 2.63494 10.8958 2.52845C10.6286 2.42195 10.3422 2.36714 10.053 2.36714C9.76381 2.36714 9.47744 2.42195 9.21025 2.52845C8.94306 2.63494 8.70029 2.79103 8.49579 2.9878L2.78657 8.48205C2.11803 9.14809 1.7481 10.0401 1.75646 10.9661C1.76483 11.892 2.15081 12.7778 2.83128 13.4325C3.51174 14.0873 4.43225 14.4587 5.39454 14.4667C6.35683 14.4748 7.28391 14.1188 7.9761 13.4755L14.205 7.48265L15.2429 8.48205L9.01474 14.4749C8.05111 15.4022 6.74413 15.9231 5.38134 15.9231C4.01854 15.9231 2.71157 15.4022 1.74793 14.4749C0.784287 13.5477 0.24292 12.2901 0.24292 10.9788C0.24292 9.66749 0.784287 8.40988 1.74793 7.48265L7.45788 1.9891Z"
              fill="#A1A1AA"
            />
          </svg>{" "}
          Attach files
        </button>
      ) : (
        <div className="flex md:gap-1 gap-1.5 md:flex-row flex-col">
          <div className="border bg-[#69AAE8] max-w-max text-white  text-sm flex  gap-1 px-3 py-1 rounded-full items-center">
            {files?.length} files attached
            <svg
              onClick={() => setFiles([])}
              className="ml-2 cursor-pointer"
              xmlns="http://www.w3.org/2000/svg"
              width="11"
              height="11"
              viewBox="0 0 11 11"
              fill="none"
            >
              <path
                d="M10.5115 9.16088C10.6456 9.29501 10.721 9.47693 10.721 9.66662C10.721 9.8563 10.6456 10.0382 10.5115 10.1724C10.3773 10.3065 10.1954 10.3818 10.0057 10.3818C9.81602 10.3818 9.63409 10.3065 9.49995 10.1724L5.72217 6.39361L1.9432 10.1712C1.80906 10.3053 1.62713 10.3806 1.43743 10.3806C1.24773 10.3806 1.0658 10.3053 0.931664 10.1712C0.797526 10.037 0.722168 9.85511 0.722168 9.66543C0.722168 9.47574 0.797526 9.29382 0.931664 9.15969L4.71063 5.38213L0.932853 1.60339C0.798716 1.46926 0.723358 1.28734 0.723358 1.09765C0.723358 0.907963 0.798716 0.726044 0.932853 0.591914C1.06699 0.457784 1.24892 0.382431 1.43862 0.382431C1.62832 0.382431 1.81025 0.457784 1.94439 0.591914L5.72217 4.37066L9.50114 0.591319C9.63528 0.457189 9.81721 0.381836 10.0069 0.381836C10.1966 0.381836 10.3785 0.457189 10.5127 0.591319C10.6468 0.725449 10.7222 0.907367 10.7222 1.09706C10.7222 1.28674 10.6468 1.46866 10.5127 1.60279L6.7337 5.38213L10.5115 9.16088Z"
                fill="white"
              />
            </svg>
          </div>
          <button
            type="button"
            onClick={() => setPopup(true)}
            className="border outline-none cursor-pointer max-w-max text-[#69AAE8] text-sm flex gap-1 px-3 py-1 rounded-full items-center"
          >
            <svg
              className="mr-1"
              xmlns="http://www.w3.org/2000/svg"
              width="11"
              height="11"
              viewBox="0 0 11 11"
              fill="none"
            >
              <path
                d="M10.0313 6.1281L6.45989 6.1281L6.45989 9.69953C6.45989 10.0924 6.13846 10.4138 5.74561 10.4138C5.35275 10.4138 5.03132 10.0924 5.03132 9.69953L5.03132 6.1281L1.45989 6.1281C1.06703 6.1281 0.745605 5.80668 0.745605 5.41382C0.745605 5.02096 1.06703 4.69953 1.45989 4.69953L5.03132 4.69953L5.03132 1.1281C5.03132 0.735247 5.35275 0.413818 5.74561 0.413818C6.13846 0.413818 6.45989 0.735247 6.45989 1.1281L6.45989 4.69953L10.0313 4.69953C10.4242 4.69953 10.7456 5.02096 10.7456 5.41382C10.7456 5.80668 10.4242 6.1281 10.0313 6.1281Z"
                fill="#69AAE8"
              />
            </svg>
            add more
          </button>
        </div>
      )}

      {popup && (
        <React.Fragment>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none font-primary bg-[#00000080]">
            <div className="relative  flex items-center justify-between lg:max-w-3xl md:max-w-2xl  sm:max-w-xl mx-auto  bg-white flex-col rounded-2xl px-4 sm:px-[40px]  py-[40px] w-11/12 sm:w-[680px]">
              <div className="flex justify-between w-full items-center">
                <h5 className="font-secondary text-[24px]  w-max font-semibold mb-4">
                  Upload your files
                </h5>
                <div className="flex items-center gap-3 ">
                <p className="text-[#858585] font-opensans text-sm font-semibold flex items-center gap-2 mb-2 p-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="21"
                      viewBox="0 0 18 21"
                      fill="none"
                    >
                      <path
                        d="M9.34974 0.5L18.0003 3.52768V10.5C18.0003 14.0701 15.8091 16.5657 13.765 18.1151C12.5319 19.0419 11.1787 19.7971 9.74247 20.3599L9.66721 20.3884L9.64559 20.3962L9.63953 20.3979L9.63694 20.3988C9.63607 20.3988 9.63521 20.3988 9.34974 19.583L9.06341 20.3997L9.05995 20.3979L9.05389 20.3962L9.03226 20.3875L8.957 20.3599C8.54901 20.2021 8.14785 20.0272 7.75458 19.8356C6.76183 19.3534 5.8175 18.7772 4.93451 18.1151C2.89126 16.5657 0.699219 14.0701 0.699219 10.5V3.52768L9.34974 0.5ZM9.34974 19.583L9.06341 20.3997L9.34974 20.5L9.63607 20.3997L9.34974 19.583ZM9.34974 18.6557L9.35752 18.6522C10.5545 18.1575 11.6842 17.5137 12.72 16.7362C14.5695 15.3356 16.2702 13.2881 16.2702 10.5V4.75606L9.34974 2.33391L2.42932 4.75606V10.5C2.42932 13.2881 4.13001 15.3339 5.9795 16.737C7.01756 17.5161 8.14995 18.1607 9.34974 18.6557ZM14.6023 7.33651L8.48555 13.4533L4.81514 9.78374L6.03918 8.55969L8.48469 11.0069L13.3783 6.11332L14.6023 7.33651Z"
                        fill="#51CC56"
                      />
                    </svg>
                    <span> Your data is secure</span>
                  </p>
                <img
                  src={Closebutton}
                  alt="/"
                  onClick={() => {
                    setPopup(false);
                  }}
                  className="cursor-pointer mb-2 bg-white p-2 rounded-[4px]  border-2 border-[#0000001a] "
                />
                </div>
              </div>
              <div
                className={` w-full h-auto rounded-lg mt-3 flex items-center justify-center relative flex-col`}
              >
                <label htmlFor="file" className="cursor-pointer w-full">
                  <div className="w-full flex items-center justify-center">
                    <input
                      multiple
                      type="file"
                      id="file"
                      placeholder=".pdf, .docx, .txt"
                      value=""
                      className={`inputfile cursor-pointer `}
                      onChange={onFileUpload}
                    />
                  </div>

                  <div className="flex flex-col bg-[#EBF3FF] border-dashed border border-[#95BFFF] w-full rounded-lg p-5 font-arial text-new text-quotetext-200 ">
                    <div className="w-full mr-2 flex gap-2 font-arial mb-3 sm:mb-0 items-center justify-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="24"
                        viewBox="0 0 25 24"
                        fill="none"
                      >
                        <path
                          d="M12.5 0C9.32935 0.0384714 6.29941 1.3151 4.05726 3.55726C1.8151 5.79941 0.538471 8.82935 0.5 12C0.538471 15.1706 1.8151 18.2006 4.05726 20.4427C6.29941 22.6849 9.32935 23.9615 12.5 24C15.6706 23.9615 18.7006 22.6849 20.9427 20.4427C23.1849 18.2006 24.4615 15.1706 24.5 12C24.4615 8.82935 23.1849 5.79941 20.9427 3.55726C18.7006 1.3151 15.6706 0.0384714 12.5 0ZM19.3571 12.8571H13.3571V18.8571H11.6429V12.8571H5.64286V11.1429H11.6429V5.14286H13.3571V11.1429H19.3571V12.8571Z"
                          fill="#2A7CF8"
                        />
                      </svg>
                      <p className="text-xl font-semibold text-black leading-6 font-opensans">
                        <span className="text-[#2A7CF8]">Add files</span>
                      </p>
                    </div>
                    <p className="text-[12px] mt-3 text-center font-opensans text-[#8A8A8A]">
                      Supported files .pdf, .docx, .txt.
                      <br /> Maximum file upload size: 200mb
                    </p>
                  </div>
                </label>

                <div
                  className={`${
                    files?.length != 0
                      ? "max-h-[175px] mt-4 w-full overflow-y-auto"
                      : ""
                  } `}
                >
                  {files?.length > 0 &&
                    files?.map(
                      (
                        {
                          name,
                          id,
                          noOfWords,
                          documentSize,
                          documentType,
                          message,
                          size,
                        },
                        i
                      ) => (
                             // <div
                        //   className={`flex justify-between gap-1  items-center w-full ${
                        //     !ValidFileType(name)
                        //       ? "border border-[#FFA4A4] bg-[#FFF5F5]"
                        //       : "border border-[#2A7CF8]"
                        //   }  mb-2 p-4 rounded-xl`}
                        //   key={id}
                        // >
                        <div
                        className={`flex justify-between gap-1  items-center w-full border border-[#2A7CF8]  mb-2 p-4 rounded-xl`}
                        key={id}
                      >
                   
                          <div className="md:flex  justify-between w-full items-center gap-12">
                            <div className="flex items-center gap-4 font-arial w-full">
                              {/* {ValidFileType(name) ? ( */}
                                <img src={Fileicon} alt="/" />
                              {/* ) : ( */}
                                {/* <div className="relative">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="32"
                                    height="36"
                                    viewBox="0 0 32 36"
                                    fill="none"
                                  >
                                    <path
                                      d="M18.8733 0.679016V10.5252C18.8733 11.3956 19.2191 12.2304 19.8346 12.8459C20.4501 13.4614 21.2849 13.8072 22.1554 13.8072H32.0015V30.2175C32.0015 31.0879 31.6557 31.9227 31.0402 32.5382C30.4247 33.1537 29.5899 33.4995 28.7195 33.4995H17.5441C19.2426 31.7315 20.2802 29.4323 20.4822 26.9889C20.6842 24.5455 20.0384 22.1071 18.6533 20.0841C17.2683 18.0611 15.2287 16.5769 12.8777 15.8814C10.5267 15.1859 8.00785 15.3216 5.74512 16.2655V3.96107C5.74512 3.09061 6.0909 2.25581 6.70641 1.64031C7.32191 1.0248 8.15671 0.679016 9.02717 0.679016H18.8733ZM21.3349 1.49953V10.5252C21.3349 10.7428 21.4213 10.9515 21.5752 11.1054C21.7291 11.2592 21.9378 11.3457 22.1554 11.3457H31.181L21.3349 1.49953Z"
                                      fill="#AEAEAE"
                                    />
                                    <path
                                      d="M18.0513 26.2954C18.0513 27.4806 17.8178 28.6543 17.3642 29.7493C16.9107 30.8444 16.2458 31.8393 15.4077 32.6774C14.5696 33.5156 13.5746 34.1804 12.4796 34.634C11.3846 35.0875 10.2109 35.321 9.02564 35.321C7.84038 35.321 6.66672 35.0875 5.57168 34.634C4.47664 34.1804 3.48166 33.5156 2.64355 32.6774C1.80544 31.8393 1.14062 30.8444 0.687036 29.7493C0.233455 28.6543 -1.76618e-08 27.4806 0 26.2954C3.56696e-08 23.9016 0.950913 21.6059 2.64355 19.9133C4.33618 18.2206 6.63189 17.2697 9.02564 17.2697C11.4194 17.2697 13.7151 18.2206 15.4077 19.9133C17.1004 21.6059 18.0513 23.9016 18.0513 26.2954ZM9.02564 20.5518C8.80803 20.5518 8.59933 20.6382 8.44545 20.7921C8.29157 20.946 8.20513 21.1547 8.20513 21.3723V27.9364C8.20513 28.154 8.29157 28.3627 8.44545 28.5166C8.59933 28.6704 8.80803 28.7569 9.02564 28.7569C9.24325 28.7569 9.45195 28.6704 9.60583 28.5166C9.75971 28.3627 9.84615 28.154 9.84615 27.9364V21.3723C9.84615 21.1547 9.75971 20.946 9.60583 20.7921C9.45195 20.6382 9.24325 20.5518 9.02564 20.5518ZM9.02564 32.2441C9.29766 32.2441 9.55853 32.136 9.75088 31.9437C9.94322 31.7513 10.0513 31.4904 10.0513 31.2184C10.0513 30.9464 9.94322 30.6855 9.75088 30.4932C9.55853 30.3008 9.29766 30.1928 9.02564 30.1928C8.75362 30.1928 8.49275 30.3008 8.3004 30.4932C8.10806 30.6855 8 30.9464 8 31.2184C8 31.4904 8.10806 31.7513 8.3004 31.9437C8.49275 32.136 8.75362 32.2441 9.02564 32.2441Z"
                                      fill="#F14848"
                                    />
                                  </svg>
                                </div>
                              )} */}

                              <p className="flex flex-col ">
                                <span
                                  className="text-[#0B0B0B]  font-opensans text-sm font-normal"
                                  // style={{ wordWrap: "break-word" }}
                                  style={{ wordBreak: "break-all" }}
                                >
                                  {name}
                                </span>
                                {/* {ValidFileType(name) ? ( */}
                                  <span className="text-[#8B8B8B] text-[12px] font-bold font-opensans uppercase">
                                    {fileSize(size)}{" "}
                                    <span className="ml-2.5">
                                      {name.split(".").pop()}
                                    </span>
                                  </span>
                                {/* ) : (
                                  <span className="text-[#ff0000] text-[12px] font-opensans font-bold uppercase">
                                    {fileSize(size)}{" "}
                                    <span className="ml-2.5">
                                      {name.split(".").pop()}
                                    </span>
                                  </span>
                                )} */}
                              </p>
                            </div>
                            <div className="flex gap-2">
                              <div
                                onClick={() => handleDeleteFile(i)}
                                className="hidden md:block cursor-pointer  h-6 bg-transparent filter-black"
                              >
                                <svg
                                  width="15"
                                  height="16"
                                  viewBox="0 0 15 16"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    id="Vector"
                                    d="M0.314703 1.0647C0.414208 0.964947 0.532416 0.8858 0.662555 0.831798C0.792695 0.777796 0.93221 0.75 1.07311 0.75C1.21401 0.75 1.35352 0.777796 1.48366 0.831798C1.6138 0.8858 1.73201 0.964947 1.83152 1.0647L7.50028 6.73561L13.169 1.0647C13.2686 0.965108 13.3869 0.886104 13.517 0.832204C13.6471 0.778303 13.7866 0.750561 13.9275 0.750561C14.0683 0.750561 14.2078 0.778303 14.3379 0.832204C14.468 0.886104 14.5863 0.965108 14.6859 1.0647C14.7855 1.1643 14.8645 1.28254 14.9184 1.41266C14.9723 1.54279 15 1.68226 15 1.82311C15 1.96396 14.9723 2.10343 14.9184 2.23356C14.8645 2.36368 14.7855 2.48192 14.6859 2.58152L9.01495 8.25028L14.6859 13.919C14.7855 14.0186 14.8645 14.1369 14.9184 14.267C14.9723 14.3971 15 14.5366 15 14.6775C15 14.8183 14.9723 14.9578 14.9184 15.0879C14.8645 15.218 14.7855 15.3363 14.6859 15.4359C14.5863 15.5355 14.468 15.6145 14.3379 15.6684C14.2078 15.7223 14.0683 15.75 13.9275 15.75C13.7866 15.75 13.6471 15.7223 13.517 15.6684C13.3869 15.6145 13.2686 15.5355 13.169 15.4359L7.50028 9.76495L1.83152 15.4359C1.73192 15.5355 1.61368 15.6145 1.48356 15.6684C1.35343 15.7223 1.21396 15.75 1.07311 15.75C0.932261 15.75 0.79279 15.7223 0.662663 15.6684C0.532535 15.6145 0.414299 15.5355 0.314703 15.4359C0.215108 15.3363 0.136104 15.218 0.0822038 15.0879C0.0283032 14.9578 0.000560843 14.8183 0.000560843 14.6775C0.000560843 14.5366 0.0283032 14.3971 0.0822038 14.267C0.136104 14.1369 0.215108 14.0186 0.314703 13.919L5.98561 8.25028L0.314703 2.58152C0.214947 2.48201 0.1358 2.3638 0.0817982 2.23366C0.0277962 2.10352 0 1.96401 0 1.82311C0 1.68221 0.0277962 1.5427 0.0817982 1.41256C0.1358 1.28242 0.214947 1.16421 0.314703 1.0647Z"
                                    fill="#000000"
                                  />
                                </svg>
                              </div>
                            </div>
                          </div>

                          <div
                            onClick={() => handleDeleteFile(i)}
                            className="block md:hidden cursor-pointer  h-6 bg-transparent filter-black"
                          >
                            <svg
                              width="15"
                              height="16"
                              viewBox="0 0 15 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                id="Vector"
                                d="M0.314703 1.0647C0.414208 0.964947 0.532416 0.8858 0.662555 0.831798C0.792695 0.777796 0.93221 0.75 1.07311 0.75C1.21401 0.75 1.35352 0.777796 1.48366 0.831798C1.6138 0.8858 1.73201 0.964947 1.83152 1.0647L7.50028 6.73561L13.169 1.0647C13.2686 0.965108 13.3869 0.886104 13.517 0.832204C13.6471 0.778303 13.7866 0.750561 13.9275 0.750561C14.0683 0.750561 14.2078 0.778303 14.3379 0.832204C14.468 0.886104 14.5863 0.965108 14.6859 1.0647C14.7855 1.1643 14.8645 1.28254 14.9184 1.41266C14.9723 1.54279 15 1.68226 15 1.82311C15 1.96396 14.9723 2.10343 14.9184 2.23356C14.8645 2.36368 14.7855 2.48192 14.6859 2.58152L9.01495 8.25028L14.6859 13.919C14.7855 14.0186 14.8645 14.1369 14.9184 14.267C14.9723 14.3971 15 14.5366 15 14.6775C15 14.8183 14.9723 14.9578 14.9184 15.0879C14.8645 15.218 14.7855 15.3363 14.6859 15.4359C14.5863 15.5355 14.468 15.6145 14.3379 15.6684C14.2078 15.7223 14.0683 15.75 13.9275 15.75C13.7866 15.75 13.6471 15.7223 13.517 15.6684C13.3869 15.6145 13.2686 15.5355 13.169 15.4359L7.50028 9.76495L1.83152 15.4359C1.73192 15.5355 1.61368 15.6145 1.48356 15.6684C1.35343 15.7223 1.21396 15.75 1.07311 15.75C0.932261 15.75 0.79279 15.7223 0.662663 15.6684C0.532535 15.6145 0.414299 15.5355 0.314703 15.4359C0.215108 15.3363 0.136104 15.218 0.0822038 15.0879C0.0283032 14.9578 0.000560843 14.8183 0.000560843 14.6775C0.000560843 14.5366 0.0283032 14.3971 0.0822038 14.267C0.136104 14.1369 0.215108 14.0186 0.314703 13.919L5.98561 8.25028L0.314703 2.58152C0.214947 2.48201 0.1358 2.3638 0.0817982 2.23366C0.0277962 2.10352 0 1.96401 0 1.82311C0 1.68221 0.0277962 1.5427 0.0817982 1.41256C0.1358 1.28242 0.214947 1.16421 0.314703 1.0647Z"
                                fill="#000000"
                              />
                            </svg>
                          </div>
                          {/* <FontAwesomeIcon
                        icon={faTrash}
                        className="text-red w-6 cursor-pointer"
                        onClick={() => handleDeleteFile(id)}
                      /> */}
                        </div>
                      )
                    )}
                </div>
                {files?.length != 0 && (
                  <SendMail unSupportedFile={unSupportedFile} />
                )}
              </div>

              <button
                type="button"
                disabled={unSupportedFile}
                className={` ${
                  files?.length != 0 && !unSupportedFile
                    ? " bg-orange mt-6"
                    : "bg-[#00000033] mt-8 "
                } rounded-full py-[14px] text-xl px-20 text-white  
                font-opensans font-bold block mx-auto`}
                onClick={() => setPopup(false)}
              >
                {loader === "loading" ? <Loader /> : "Continue"}
              </button>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </React.Fragment>
      )}
    </>
  );
};

export default AttachFile;
